import * as tslib_1 from "tslib";
import { Action, Selector, State } from '@ngxs/store';
import { takeUntil, tap } from 'rxjs/operators';
import { FetchOrder, FetchOnboardingGoals } from './onboarding.actions';
import { Logout } from './auth.actions';
let OnboardingState = class OnboardingState {
    constructor(actions, onboardingRepository) {
        this.actions = actions;
        this.onboardingRepository = onboardingRepository;
    }
    static order(state) {
        return state.order;
    }
    static orders(state) {
        return state.goals;
    }
    fetchOnboardingGoals(ctx, action) {
        let request = this.onboardingRepository.listByAccountId(action.accountId)
            .pipe(tap(response => {
            ctx.patchState({
                goals: response.data.items
            });
        }));
        if (action.cancellationToken) {
            request = request.pipe(takeUntil(action.cancellationToken));
        }
        return request;
    }
    fetchOrder(ctx, action) {
        let request = this.onboardingRepository.findByAccountIdAndOrderNo(action.accountId, action.orderNo)
            .pipe(tap(response => ctx.patchState({
            order: response.data
        })));
        if (action.cancellationToken) {
            request = request.pipe(takeUntil(action.cancellationToken));
        }
        return request;
    }
    logout(ctx, action) {
        ctx.patchState({
            order: null,
            goals: null,
        });
    }
};
tslib_1.__decorate([
    Action(FetchOnboardingGoals)
], OnboardingState.prototype, "fetchOnboardingGoals", null);
tslib_1.__decorate([
    Action(FetchOrder)
], OnboardingState.prototype, "fetchOrder", null);
tslib_1.__decorate([
    Action(Logout)
], OnboardingState.prototype, "logout", null);
tslib_1.__decorate([
    Selector()
], OnboardingState, "order", null);
tslib_1.__decorate([
    Selector()
], OnboardingState, "orders", null);
OnboardingState = tslib_1.__decorate([
    State({
        name: 'Goals',
        defaults: {
            order: null,
            goals: [],
        }
    })
], OnboardingState);
export { OnboardingState };
